import LearningPathComponent from '@views/learning-path/show';
import LearningPathSetupComponent from '@views/learning-path/setup';

export default [
  {
    path: '/learning-path/:categoryId?/:flashcardId?',
    name: 'learningPath#show',
    component: LearningPathComponent,
  },
  {
    path: '/learning-path-setup',
    name: 'learningPath#setup',
    component: LearningPathSetupComponent,
  },
];
